export function removeSpecialChars(str) {
    if (!str) {
        return '';
    }
    return str.replace(/[^\w\s]/gi, '').replace(/[0-9]/gi, '');
}
//# sourceMappingURL=removeSpecialChars.js.map